export const sendSlackNotification = async ({ message, title }) => {
  const reformattedMessage = {
    blocks: [
      {
        type: "section",
        text: {
          type: "plain_text",
          text: `:red_circle: *GATSBY - ${title ?? "Error"}*`,
          emoji: true
        }
      },
      {
        type: "divider"
      },
      {
        type: "context",
        elements: [
          {
            type: "mrkdwn",
            text: JSON.stringify(message)
          }
        ]
      }
    ]
  };

  return await fetch("/api/slack/send", {
    method: `POST`,
    mode: "cors",
    cache: "no-cache",
    body: JSON.stringify(reformattedMessage),
    headers: {
      "content-type": `application/json`
    }
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error("error", err);
    });
};
